import React from 'react';

const NAVBAR_HEIGHT = 73;

const PlannerFrame = ({ title, src, topPaddingExtra = 0 }) => {
  const totalTopPadding = NAVBAR_HEIGHT + topPaddingExtra;

  return (
    <main
      className="bg-black"
      style={{
        paddingTop: `${totalTopPadding}px`,
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
      }}
    >
      <iframe
        title={title}
        src={src}
        style={{
          display: 'block',
          width: '100vw',
          height: `calc(100vh - ${totalTopPadding}px)`,
          border: '0',
          margin: '0',
          padding: '0',
          backgroundColor: '#0c0e14',
        }}
      />
    </main>
  );
};

export default PlannerFrame;